<template functional>
  <div class="time-line-wrapper time-line">
    <p class="time-line-timestamp" :title="props.timestamp">
      {{ props.timestamp }}
    </p>
    <div class="time-line-split">
      <div v-if="!props.finished" class="time-line__tail"></div>
      <div class="time-line__dot" :style="{ backgroundColor: props.dotColor }"></div>
    </div>
    <div class="time-line-content">
      <span style="margin-right:30px;">{{ props.context }}</span>
      <span v-if="props.addon" style="color:#000;white-space: pre;">{{ props.addon }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeLine',
  props: {
    timestamp: String,
    context: String,
    dotColor: {
      type: String,
      default: '#8998a0'
    },
    finished: Boolean,
    addon: String
  }
};
</script>

<style lang="scss">
.time-line-wrapper {
  display: flex;
  .time-line-timestamp {
    font-size: 12px;
    padding-right: 10px;
    padding-bottom: 20px;
    white-space: nowrap;
    word-spacing: 1em;
    width: 135px;
    min-width: 135px;
  }
  .time-line-split {
    position: relative;
    width: 7px;
    max-width: 7px;
    min-width: 7px;
    .time-line__tail {
      position: absolute;
      height: 100%;
      width: 1px;
      left: 3px;
      top: 4px;
      background-color: #e0e1e2;
    }
    .time-line__dot {
      top: 4px;
      position: absolute;
      height: 7px;
      width: 7px;
      border-radius: 50%;
    }
  }
  .time-line-content {
    padding-left: 23px;
    padding-bottom: 20px;
    flex: 1;
  }
}
</style>
